// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oKyp","colMin":"styles_colMin__3ygHw"};